<!-- Apple iPhone-style External Layout -->
<div class="ExternalPageContainer">

  <!-- Modern Header Bar -->
  <header class="ExternalHeader">
    <div class="ExternalHeaderContent">
      <!-- Logo/Brand -->
      <div class="ExternalBrand">
        <i class="material-icons ExternalBrandIcon">cloud_queue</i>
        <div class="ExternalBrandTextWrapper">
          <span class="ExternalBrandText">{{ 'HOME.TITLE' | translate }}</span>
          <span class="ExternalBrandTagline">{{ 'ExternalTagline' | translate }}</span>
        </div>
      </div>

      <!-- Document Info (when available) -->
      <div class="ExternalDocInfo" *ngIf="DocumentStatus || DocumentPrice">
        <div class="ExternalDocStatus" *ngIf="DocumentStatus">
          <span class="ExternalDocStatusBadge">{{DocumentStatus}}</span>
        </div>
        <div class="ExternalDocDetails" *ngIf="DocumentDueDate || DocumentPrice">
          <span class="ExternalDocDueDate" *ngIf="DocumentDueDate">
            <i class="material-icons">schedule</i>
            {{'DueDate' | translate}} {{DocumentDueDate}}
          </span>
          <span class="ExternalDocPrice" *ngIf="DocumentPrice">
            <span class="ExternalDocCurrency">{{DocumentCurrency}}</span>
            <span class="ExternalDocAmount">{{DocumentPrice}}</span>
          </span>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content Area -->
  <main class="ExternalMainContent">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <footer class="ExternalFooter">
    <span class="ExternalFooterText">© {{ currentYear }} {{ 'HOME.TITLE' | translate }}</span>
  </footer>

</div>
  